import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import { get } from 'lodash';

import { colors } from '../styles';

const styles = css`
  position: relative;
  z-index: 1;
  background-color: ${colors.brand1Darker};
  .Breadcrumbs_wrapper {
    height: auto;
    .Breadcrumbs_list {
      padding: 5px 0;
      margin: 0;
      height: 100%;
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      list-style: none;
      @media(min-width: 992px) {
        padding: 20px 0;
      }
      .Breadcrumbs_listItem {
        transition: all .3s ease-out;
        position: relative;
        padding-left: 3px;
        text-transform: capitalize;
        font-weight: 700;
        font-size: 12px;
        color: ${colors.brand2};
        letter-spacing: 0;
        line-height: 18px;
        a {
          color: ${colors.brand2};
        }
        &:hover {
          color: ${colors.brand2};
          transition: all .3s ease-out;
        }
        &::after {
          content: '/';
          margin-left: 3px;
        }
        &:last-child {
          &::after {
            content: '';
            margin-right: 0;
          }
        }
        &:last-child, &:last-child a {
          color: ${colors.white};
        }
      }
    }
  }
`;

function Breadcrumbs({ plan, community, home, area, metro, submetro }) {
  return (
    <div className={styles}>
      <div className="container">
        <div className="Breadcrumbs_wrapper">
          {
            community && !plan &&
            <ul className="Breadcrumbs_list">
              <li className="Breadcrumbs_listItem">
                <Link name="index">Home</Link>
              </li>
              {
                !area &&
                metro &&
                  [
                  (<li className="Breadcrumbs_listItem" key="metro">
                    <Link
                      name="communities"
                      community={community}
                      params={{ communityMarketAreaMetro: get(metro, 'name') }}
                    >
                      {get(metro, 'name')}
                    </Link>
                  </li>),
                  (<li className="Breadcrumbs_listItem" key="submetro">
                    <Link
                      name="communities"
                      community={community}
                      params={{ communityMarketAreaMetro: get(metro, 'name'), communityMarketAreaSubMetro: get(submetro, 'name') }}
                    >
                      {get(submetro, 'name')}
                    </Link>
                  </li>),
                  ]
              }
              {
                area &&
                  [
                  (<li className="Breadcrumbs_listItem" key="area">
                    <Link
                      name="communities"
                      community={community}
                      params={{ communityMarketArea: get(area, 'name') }}
                    >
                      {get(area, 'name')}
                    </Link>
                  </li>),
                  ]
              }
              <li className="Breadcrumbs_listItem">
                {get(community, 'name')}
              </li>
            </ul>
          }
          {
            home &&
            <ul className="Breadcrumbs_list">
              <li className="Breadcrumbs_listItem">
                <Link
                  name="homes"
                >
                  Homes
                </Link>
              </li>
              {
                !area &&
                metro &&
                  [
                  (<li className="Breadcrumbs_listItem" key="metro">
                    <Link
                      name="communities"
                      community={community}
                      params={{ communityMarketAreaMetro: get(metro, 'name') }}
                    >
                      {get(metro, 'name')}
                    </Link>
                  </li>),
                  (<li className="Breadcrumbs_listItem" key="submetro">
                    <Link
                      name="communities"
                      community={community}
                      params={{ communityMarketAreaMetro: get(metro, 'name'), communityMarketAreaSubMetro: get(submetro, 'name') }}
                    >
                      {get(submetro, 'name')}
                    </Link>
                  </li>),
                  ]
              }
              {
                area &&
                  [
                  (<li className="Breadcrumbs_listItem" key="area">
                    <Link
                      name="communities"
                      community={community}
                      params={{ communityMarketArea: get(area, 'name') }}
                    >
                      {get(area, 'name')}
                    </Link>
                  </li>),
                  ]
              }
              <li className="Breadcrumbs_listItem">
                {`${get(home, 'address.streetAddress')} ${get(home, 'address.addressLocality')}, ${get(home, 'address.addressRegion')}`}
              </li>
            </ul>
          }
          {
            plan &&
            <ul className="Breadcrumbs_list">
              <li className="Breadcrumbs_listItem">
                <Link name="index">Home</Link>
              </li>
              <li className="Breadcrumbs_listItem">
                <Link name="plans">Floor Plans</Link>
              </li>
              {
                community &&
                <li className="Breadcrumbs_listItem" >
                  <Link name="plans">{get(community, 'name')}</Link>
                </li>
              }
              <li className="Breadcrumbs_listItem">
                {get(plan, 'name')}
              </li>
            </ul>
          }
        </div>
      </div>
    </div>
  );
}

Breadcrumbs.propTypes = {
  plan: PropTypes.object,
  community: PropTypes.object,
  home: PropTypes.object,
  area: PropTypes.object,
  metro: PropTypes.object,
  submetro: PropTypes.object,
};

Breadcrumbs.defaultProps = {
  plan: undefined,
  community: undefined,
  home: undefined,
  area: undefined,
  metro: undefined,
  submetro: undefined,
};


export default withData(
  {
    area: true,
    metro: true,
    submetro: true,
  },
  {
    required: {},
  },
)(Breadcrumbs);



// WEBPACK FOOTER //
// ./src/components/Breadcrumbs.js